export function getDOMFillerCard(style) {

  let fillerCard = ``;

  if (style.name == 'Nautical') {

    // grid-cols-2 md:grid-cols-3 xl:grid-cols-4

     fillerCard =  `<div class="featured-card featured-card-async filler-card nautical col-span-2 xl:col-span-1 opacity-0">
    
      <a href="${style.link}" class="relative group w-full h-full bg-white rounded-lg overflow-hidden hover:shadow-md">

        <div class="w-full h-[65%] absolute z-10 left-0 top-0 bg-ford-2" style="clip-path: polygon(0 0, 100% 0, 100% 100%, 0 70%);"> </div>

        <div class="h-full border-[3px] border-white group-hover:border-ford-2 rounded-lg"> 
      
          <div class="flex flex-col justify-between items-center relative z-30 p-8 w-full h-full">
            
              <div class="${ style.inventoryCount ? 'visible' : 'hidden' }">
                <p class="font-brand text-xl font-bold text-center text-white">
                  ${ style.inventoryCount } Vehicles Currently <br> Available
                </p>
              </div>
                    
              <img class="max-w-[400px] block flex-1 w-full aspect-[5/3] object-contain object-top"
              src="${style.imgUrl}"
              alt="Currently Available Car Image"
              itemprop="image"/>
      
              <div class="w-full">
                <div class="w-full">
                  <button class="dsp-frd-btn flex items-center justify-center gap-2 w-full text-xs font-light"> 
                    <span class="dsp-icon text-white flex justify-center items-center">
                      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_66_322)">
                      <path d="M2.5 12H6.5V10.6667H2.5V12ZM2.5 4V5.33333H14.5V4H2.5ZM2.5 8.66667H10.5V7.33333H2.5V8.66667Z" fill="white"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_66_322">
                      <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                      </clipPath>
                      </defs>
                      </svg>
                    </span>
                    ${ style.ctaTitle } 
                  </button>
                </div>
              </div>
      
          </div>

        </div>
          
      </a>
    </div>`

  }
  

    return fillerCard;

}
